import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "Virtual Market 5 \"DEFAULT CUBE\""
const scope = "VR空間体験設計・制作"
const str1 = "「バーチャルマーケット5」の会場「デフォルトキューブ」の空間体験ディレクション、制作チームの一員として主要部の制作を行った。"
const str2 = "前回に引き続きブースを呼び出すコンセプトはそのままに、プレビュー表示の改善、ジオメトリシェーダーを用いた空間把握のためのマップの追加、歩いて体験するオープニング演出の追加など、UX改善を行った。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.dcdc01.childImageSharp.original.src}
          pageimgw={data.dcdc01.childImageSharp.original.width}
          pageimgh={data.dcdc01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/dcdc01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dcdc02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dcdc03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dcdc04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dcdc05.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/dcdc06.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  dcdc01: file(relativePath: {eq: "dcdc01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
